import { createContext } from 'react';
import type { ThemeClass } from './themeClasses';

export interface ThemeContextValue {
  theme: ThemeClass;
  isDark: boolean;
  /** Flip light <-> dark, persist it, and broadcast the change. */
  toggle: () => void;
  /** Apply a theme for this session only (no persistence) - used by the logo page. */
  setTheme: (theme: ThemeClass) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
